import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageTitle } from 'components/layouts/pageTitle';
import { FormButton } from 'components/buttons/formButton';
import { TemplateVariationForm } from './_form_template_variation';

export const VariationJoinsAddEditForm = ({ itemData, isEdit }) => {
  const urlRootName = 'variation-joins';
  const navigate = useNavigate();
  const formRef = useRef(null);

  const [isSaving, setIsSaving] = useState(false);

  const onSubmitClicked = () => {
    formRef.current.click();
  };

  return (
    <>
      <PageTitle
        title="Variation joins template"
        breadcrumbs={[{ path: '/settings', title: 'Settings' }]}
      />

      <div className="container mx-auto px-2 md:px-6 lg:px-8">
        <div className="w-full">
          <div className="shadow sm:rounded-md sm:overflow-hidden">
            <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
              <div>
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  {isEdit ? ` Editing ${itemData?.template_name}` : 'Add new variation join'}
                </h3>
              </div>
              <TemplateVariationForm
                itemData={itemData}
                isEdit={isEdit}
                ref={formRef}
                isProductVariation={false}
                setIsSaving={setIsSaving}
              />
            </div>
            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <button
                type="button"
                className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                onClick={() => navigate(`/settings/${urlRootName}`)}
              >
                Cancel
              </button>

              <FormButton onClick={onSubmitClicked} text={isEdit ? 'Save' : 'Add new'} isLoading={isSaving} />
            </div>
          </div>

        </div>
      </div>
    </>
  );
};
